
<div *ngIf="checkRole()">
                             
  <div *ngIf="checkRevision()" style="display: flex;justify-content: space-around">
      <p style="margin: 0;position: relative;color: black;top: 5px;">{{ data.revision  }}</p>
      <button pButton type="button" icon="pi pi-unlock" class="ui-button-info" (click)="changeValueRevision();"></button> 
 </div>
 <div *ngIf="!checkRevision()" style="display: flex;justify-content: space-around">
  <p style="margin: 0;position: relative;color: black;top: 5px;"> - </p>
  <button pButton type="button" icon="pi pi-lock" class="ui-button-danger" (click)="changeValueRevision();"></button> 
</div>
